import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'lib-canvas-swipe-tool',
  standalone: true,
  template: `
    <button
      class="cv-tb__btn"
      [class.cv-tb__btn--active]="active"
      (click)="swipe.emit()"
      [title]="active ? 'Stop swipe comparison' : 'Swipe compare layers vs base map'"
      type="button"
    >
      <!-- Split-screen / swipe icon -->
      <svg class="cv-toolbar-icon-img" viewBox="0 0 24 24" fill="none" stroke="currentColor"
           stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <rect x="3" y="3" width="18" height="18" rx="2"/>
        <line x1="12" y1="3" x2="12" y2="21"/>
        <polyline points="9 8 7 12 9 16"/>
        <polyline points="15 8 17 12 15 16"/>
      </svg>
    </button>
  `,
  encapsulation: ViewEncapsulation.None,
})
export class SwipeToolComponent {
  @Input() active = false;
  @Output() swipe = new EventEmitter<void>();
}
